module.exports = __webpack_public_path__ + "img/20180815_154807_254.4850c4ac.jpg";